import { isEmpty } from "lodash";
import { DeployedAsTypeValues } from "../constants/listingTypes";
import { ProjectContainer, ProjectKeys, ProjectTypes } from "../constants/project";
import type { ProjectListGraphQLResponseDataEntity } from "../interfaces/graphql";

enum LocalDeployedAsSet {
	rhelNonContainer = "rhelNonContainer",
}
export enum DeployedAsSetType {
	helmChart = DeployedAsTypeValues.helmChart,
	operator = DeployedAsTypeValues.operator,
	containers = ProjectTypes.containers,
	openstackAppContainer = ProjectTypes.openstackAppContainer,
	rhel = ProjectTypes.rhel,
	openShiftCnf = ProjectTypes.openShiftCnf,
	openShiftVirtualization = ProjectTypes.openShiftVirtualization,
	rhelNonContainer = LocalDeployedAsSet.rhelNonContainer,
	openstackVNF = ProjectTypes.openstackVNF,
	openStackInfraContainer = ProjectTypes.openStackInfraContainer,
	openStackInfraNonContainer = ProjectTypes.openStackInfraNonContainer,
}
export const getDeployedAsSet = (certProjectList: ProjectListGraphQLResponseDataEntity[]): Set<DeployedAsSetType> => {
	const deployedAsType: Set<DeployedAsSetType> = new Set();
	certProjectList
		?.filter((item) => item?.[ProjectKeys.projectStatus] === "active")
		.forEach((item) => {
			if (item?.[ProjectKeys.type] === ProjectTypes.helmChart) {
				deployedAsType.add(DeployedAsSetType.helmChart);
			} else if (
				item?.[ProjectKeys.type] === ProjectTypes.containers &&
				item?.[ProjectKeys.container]?.[ProjectContainer.type] === "operator bundle image"
			) {
				deployedAsType.add(DeployedAsSetType.operator);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.containers) {
				deployedAsType.add(DeployedAsSetType.containers);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.rhel) {
				if (!isEmpty(item?.[ProjectKeys.container])) {
					deployedAsType.add(DeployedAsSetType.rhel);
				} else {
					deployedAsType.add(DeployedAsSetType.rhelNonContainer);
				}
			} else if (item?.[ProjectKeys.type] === ProjectTypes.openstackAppContainer) {
				deployedAsType.add(DeployedAsSetType.openstackAppContainer);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.openShiftCnf) {
				deployedAsType.add(DeployedAsSetType.openShiftCnf);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.openShiftVirtualization) {
				deployedAsType.add(DeployedAsSetType.openShiftVirtualization);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.openstackVNF) {
				deployedAsType.add(DeployedAsSetType.openstackVNF);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.openStackInfraContainer) {
				deployedAsType.add(DeployedAsSetType.openStackInfraContainer);
			} else if (item?.[ProjectKeys.type] === ProjectTypes.openStackInfraNonContainer) {
				deployedAsType.add(DeployedAsSetType.openStackInfraNonContainer);
			}
		});
	return deployedAsType;
};

export const getAttachedProjectBadge = (
	certProjectList: ProjectListGraphQLResponseDataEntity[],
): string | undefined => {
	return certProjectList.filter((elm) => elm.badges)?.map((elm) => elm?.badges?.[0])?.[0];
};
export const getAttachedProjectBadgeSet = (certProjectList: ProjectListGraphQLResponseDataEntity[]) => {
	return new Set(
		certProjectList?.map((elm) => elm?.badges || [])?.reduce((acc, badges) => acc.concat(badges), []) || [],
	);
};
